import { PATH_ADD_OKR, PATH_NOPC } from "@/constants/URL";
import routerWithSidebar from "../routerWithSidebar";
import { ispc } from "@/utils/func";

export default {
  path: PATH_ADD_OKR,
  components: routerWithSidebar(() =>
    import(/* webpackChunkName: "role" */ "@/views/myinfo/myokr/AddOkr.vue")
  ),
  beforeEnter: (to, from, next) => {
    if (!ispc) {
      next({
        path: PATH_NOPC,
      });
    } else {
      next();
    }
  },
};
